import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import { mpesaApi, MpesaStatus, type MpesaStkPushRequest } from "../services/mpesaApi";

export const useInitiateStkPush = () => {
  return useMutation({
    mutationFn: (payload: MpesaStkPushRequest) => mpesaApi.initiateStkPush(payload),
    onSuccess: (transaction) => {
      // Invalidate payments so the linked payment record shows up
      queryClient.invalidateQueries({ queryKey: ["payments"] });
      queryClient.invalidateQueries({
        queryKey: ["payments", "order", transaction.orderId],
      });
      // Invalidate orders as balance may have changed
      queryClient.invalidateQueries({ queryKey: ["orders"] });
      queryClient.invalidateQueries({ queryKey: ["orders", transaction.orderId] });
    },
  });
};

/** Polls the M-Pesa request status every 3 seconds until it leaves Pending. */
export const usePollMpesaStatus = (transactionId: string | null) => {
  return useQuery({
    queryKey: ["mpesa-request", transactionId],
    queryFn: () => mpesaApi.getRequest(transactionId!),
    enabled: !!transactionId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      // Keep polling while still Pending
      return status === MpesaStatus.Pending ? 3_000 : false;
    },
    // Don't cache stale data between polls
    staleTime: 0,
  });
};
